import { render, staticRenderFns } from "./ProductCategoryTreeItem.vue?vue&type=template&id=a603e79a&scoped=true&lang=pug&"
import script from "./ProductCategoryTreeItem.vue?vue&type=script&lang=js&"
export * from "./ProductCategoryTreeItem.vue?vue&type=script&lang=js&"
import style0 from "./ProductCategoryTreeItem.vue?vue&type=style&index=0&id=a603e79a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a603e79a",
  null
  
)

export default component.exports